<template>
  <MainLayout
    :currentLang="currentLang"
    :contactTxt="'From Prospecting to Win—Faster with Xpirory！'"
    :contactMobileTxt="$t('message.contactTxtMobile')"
  >
    <!-- banner -->
    <section class="banner-section home">
      <div class="banner-content w-page fly-in">
        <div class="text">
          <p v-html="$t('message.index.banner.title')"></p>
        </div>
        <div class="desc" v-html="$t('message.index.banner.desc')"></div>
        <div class="input-box">
          <el-input class="w-100" type="text" placeholder="Business Email" v-model="businessEmail"></el-input>
          <el-button type="primary" @click="jumpContact">Free Trial</el-button>
        </div>
        <div class="desc2">
          By submitting this form, you agree to our Terms of Use, Privacy Policy, and consent to
          <br />
          receiving marketing communications from us.
        </div>
      </div>
    </section>

    <!-- 业务环节 -->
    <section class="w-page section business-section">
      <div class="section-title">
        <h2>
          How We Accelerate
          <br />
          B2B Prospecting-to-Win Growth
        </h2>
      </div>

      <div class="business-content">
        <div class="stage-content">
          <div class="stage-list d-flex align-items-center justify-content-center">
            <div class="prospecting">
              Prospecting
            </div>
            <div class="line line1"></div>
            <div class="stage-item" :class="selectStage == '0' ? 'active' : ''">
              <div class="stage-text">
                Lead
              </div>
              <div class="stage-inner" @mouseover="changeStage('0')">
                <img src="@/assets/images/home/check.svg" class="w-100 h-100 check" alt="" />
                <img src="@/assets/images/home/check-active.svg" class="w-100 h-100 check-active" alt="" />
              </div>
            </div>
            <div class="line line1"></div>
            <div class="stage-item" :class="selectStage == '1' ? 'active' : ''">
              <div class="stage-text">
                Qualification
              </div>
              <div class="stage-inner" @mouseover="changeStage('1')">
                <img src="@/assets/images/home/check.svg" class="w-100 h-100 check" alt="" />
                <img src="@/assets/images/home/check-active.svg" class="w-100 h-100 check-active" alt="" />
              </div>
            </div>
            <div class="line line2"></div>
            <div class="stage-item" :class="selectStage == '2' ? 'active' : ''">
              <div class="stage-text">
                Engagement
              </div>
              <div class="stage-inner" @mouseover="changeStage('2')">
                <img src="@/assets/images/home/check.svg" class="w-100 h-100 check" alt="" />
                <img src="@/assets/images/home/check-active.svg" class="w-100 h-100 check-active" alt="" />
              </div>
            </div>
            <div class="line line3"></div>
            <div class="stage-item" :class="selectStage == '3' ? 'active' : ''">
              <div class="stage-text">
                Demo
              </div>
              <div class="stage-inner" @mouseover="changeStage('3')">
                <img src="@/assets/images/home/check.svg" class="w-100 h-100 check" alt="" />
                <img src="@/assets/images/home/check-active.svg" class="w-100 h-100 check-active" alt="" />
              </div>
            </div>
            <div class="line line4"></div>
            <div class="stage-item" :class="selectStage == '4' ? 'active' : ''">
              <div class="stage-text">
                Proposal
              </div>
              <div class="stage-inner" @mouseover="changeStage('4')">
                <img src="@/assets/images/home/check.svg" class="w-100 h-100 check" alt="" />
                <img src="@/assets/images/home/check-active.svg" class="w-100 h-100 check-active" alt="" />
              </div>
            </div>
            <div class="line line5"></div>
            <div class="stage-item" :class="selectStage == '5' ? 'active' : ''">
              <div class="stage-text">
                Negotiation and commitment
              </div>
              <div class="stage-inner" @mouseover="changeStage('5')">
                <img src="@/assets/images/home/check.svg" class="w-100 h-100 check" alt="" />
                <img src="@/assets/images/home/check-active.svg" class="w-100 h-100 check-active" alt="" />
              </div>
            </div>
            <div class="line line6"></div>
            <div class="triangle"></div>
            <div class="lead-or-win">
              Win
            </div>
          </div>
        </div>
        <div class="btn-outer">
          <div class="btn-wrap d-flex">
            <div
              class="btn"
              v-for="(item, index) in businessData.slice(0, 5)"
              :key="index"
              :class="[matchPlatformClass(item.id) == 'main' ? 'active' : '', matchPlatformClass(item.id) == 'minor' ? 'minor' : '']"
              @click="changePlatform(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="btn-wrap d-flex">
            <div
              class="btn"
              v-for="(item, index) in businessData.slice(5, 8)"
              :key="index"
              :class="[matchPlatformClass(item.id) == 'main' ? 'active' : '', matchPlatformClass(item.id) == 'minor' ? 'minor' : '']"
              @click="changePlatform(item.id)"
            >
              {{ item.name }}
            </div>
          </div>

        </div>

        <div class="platform-content">
          <div
            class="label auto-hyphen"
            v-if="selectPlatformInfo.label"
            v-html="$store.state.screenWidth > 768 ? selectPlatformInfo.label : selectPlatformInfo.label.replace(/<br\s*\/?>/g, '')"
          ></div>
          <div class="video-wrap" v-if="videoAlive">
            <video controls muted autoplay height="100%">
              <source :src="selectPlatformInfo.videoUrl" type="video/mp4" />
              Your browser does not support the video element.
            </video>
          </div>
        </div>
      </div>
    </section>

    <!-- 一 -->
    <section class="w-page section tool-section first">
      <div class="section-title text-left">
        <h2>Boost Opportunity Conversion</h2>
      </div>

      <div class="tool-content">
        <div class="tool-item d-flex justify-content-between">
          <div class="left-wrap">
            <div
              class="left-item"
              @click="changeTool(1, item.id)"
              v-for="(item, index) in toolData1"
              :key="index"
              :class="[item.id == selectTool1 ? 'active' : '']"
            >
              <div class="item-title d-flex justify-content-between">
                <div v-html="item.name"></div>
                <i class="el-icon-arrow-right fs_22"></i>
              </div>
              <div class="item-desc">
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="right-video h-100">
            <img :src="selectToolInfo1.img" class="w-100" alt="" />
          </div>
        </div>
      </div>
    </section>

    <!-- 二 -->
    <section class="w-page section tool-section second">
      <div class="section-title text-right pr-3">
        <h2>Improve Sales Efficiency</h2>
      </div>

      <div class="tool-content special">
        <div class="tool-item d-flex justify-content-between">
          <div class="left-wrap">
            <div
              class="left-item"
              @click="changeTool(2, item.id)"
              v-for="(item, index) in toolData2"
              :key="index"
              :class="[item.id == selectTool2 ? 'active' : '']"
            >
              <div class="item-title d-flex justify-content-between">
                <div v-html="item.name"></div>
                <i class="el-icon-arrow-right fs_22"></i>
              </div>
              <div class="item-desc">
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="right-video">
            <img :src="selectToolInfo2.img" class="w-100" alt="" />
          </div>
        </div>
      </div>
    </section>

    <!-- 三 -->
    <section class="w-page section tool-section">
      <div class="section-title text-left">
        <h2>Reduce Sales & Operational Costs</h2>
      </div>

      <div class="tool-content">
        <div class="tool-item d-flex justify-content-between">
          <div class="left-wrap">
            <div
              class="left-item"
              @click="changeTool(3, item.id)"
              v-for="(item, index) in toolData3"
              :key="index"
              :class="[item.id == selectTool3 ? 'active' : '']"
            >
              <div class="item-title d-flex justify-content-between">
                <div v-html="item.name"></div>
                <i class="el-icon-arrow-right fs_22"></i>
              </div>
              <div class="item-desc">
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="right-video">
            <img :src="selectToolInfo3.img" class="w-100" alt="" />
          </div>
        </div>
      </div>
    </section>

    <!-- 了解Xpirory的优势 -->
    <section class="w-page section advantage-section">
      <div class="section-title">
        <h2>What Sets Us Apart?</h2>
      </div>

      <div class="desc">
        Xpirory helps you accelerate the entire B2B journey — from prospecting to winning. Try it free and experience the difference.
      </div>

      <div class="advantage-content p-relative">
        <!-- <img width="100%" v-if="true" src="@/assets/images/home/advantage-poster.png" alt="" /> -->
        <video controls muted width="100%" height="100%" ref="videoPlayer">
          <source src="@/assets/images/home/advantage.mp4" type="video/mp4" />
          Your browser does not support the video element.
        </video>
        <div class="p-absolute play-btn" v-if="!isPlay" @click="playVideo">
          <img src="@/assets/images/home/video-play.png" alt="">
        </div>
      </div>
    </section>

    <!-- 不同 -->
    <section class="w-page section different-section">
      <div class="section-title">
        <h2>What Makes us different</h2>
      </div>

      <div class="section-desc auto-hyphen">
        We build a complete Prospecting-to-Win AI engine, not just standalone tools.From discovering high-fit prospects to understanding customers, generating solutions, and delivering immersive demos, Xpirory empowers sales teams to execute every stage with greater speed, precision, and efficiency.
      </div>

      <div class="different-content">
        <div class="list d-flex">
          <div class="list-item" v-for="(item, index) in differentData" :key="index">
            <div class="item-inner">
              <div class="label" v-html="item.label"></div>
              <div class="desc">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>

        <div class="stats-grid">
          <template>
            <div class="stat-item" v-for="(item, index) in dataList" :key="index">
              <div class="stat-label text-left">{{ item.label }}</div>
              <div class="stat-number">
                <span class="stat-unit mr-1">></span>
                <countTo :startVal="0" :endVal="item.value" :duration="3000"></countTo>
                <span class="stat-unit ml-1">{{ item.unit }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>

    <div class="w-page section valuation-section">
      <div class="section-title">
        <h2>What Our Users Say</h2>
      </div>

      <div class="valuation-container">
        <div class="valuation-content">
          <div class="valuation-col">
            <vue-seamless-scroll :data="fifthListData.concat(fifthListData)" :class-option="{ step: 0.5, direction: 2 }">
              <div class="valuation-list h-100">
                <div class="valuation-item" v-for="(item, index) in fifthListData" :key="index">
                  <div class="user-wrap">
                    <div class="avatar">
                      <img :src="item.avatar" alt="" />
                    </div>
                    <div class="user-info">
                      <div class="user-name">
                        {{ item.name }}
                      </div>
                      <div class="user-industry">
                        {{ item.industry }}
                      </div>
                    </div>
                  </div>
                  <div class="top-content">
                    {{ item.content }}
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '../components/MainLayout.vue';
import SingleCycleDisplay from '../components/CycleDisplay.vue';
import vueSeamlessScroll from 'vue-seamless-scroll';
import countTo from 'vue-count-to';

export default {
  name: 'Home',
  props: ['currentLang'],
  inject: ['toVisualBudgetCenter'],
  components: {
    MainLayout,
    SingleCycleDisplay,
    vueSeamlessScroll,
    countTo,
  },
  data() {
    return {
      isPlay: false,
      dataList: [
        {
          value: 50,
          unit: '%',
          label: 'Reduced Sales Costs',
        },
        {
          value: 300,
          unit: '%',
          label: 'Higher Lead Conversion Rates',
        },
        {
          value: 50,
          unit: '%',
          label: 'Increased Win Rates',
        },
        {
          value: 30,
          unit: '%',
          label: 'Shorter Sales Cycles',
        },
      ],
      businessData: [
        {
          id: '0',
          name: 'AI Prospecting Agent',
          label: 'Automatically discover, analyze, qualify, and engage high-fit target accounts before they enter your sales pipeline.',
          videoUrl: require('@/assets/images/home/platform0.mp4'),
        },
        {
          id: '1',
          name: 'Customer Deep Insight',
          label:
            'Get a tailored analysis of each target account—its needs, priorities, and potential partnership opportunities. Our AI gives you a full 360° view of the customer’s business, helping you communicate with greater accuracy, relevance, and efficiency.',
          videoUrl: require('@/assets/images/home/platform1.mp4'),
        },
        {
          id: '2',
          name: 'Sales Email Coach',
          label:
            'Generate personalized communication strategies and practical scripts for every stage of the sales process, helping you overcome communication roadblocks and accelerate opportunity conversion.',
          videoUrl: require('@/assets/images/home/platform2.mp4'),
        },
        {
          id: '3',
          name: 'Smart Poster Generator',
          label:
            'Fully control text, layout, and design to reduce complexity and production time—enabling any salesperson to quickly deliver the materials customers need.',
          videoUrl: require('@/assets/images/home/platform3.mp4'),
        },
        {
          id: '4',
          name: 'Pain Point Discovery',
          label:
            'Build a visual, enterprise-specific pain-point knowledge map that gives every salesperson an expert-level perspective—so they can capture customer needs fully and accurately in a single conversation and maximize opportunities.',
          videoUrl: require('@/assets/images/home/platform4.mp4'),
        },
        {
          id: '5',
          name: 'Operation Simulation and Analysis Platform',
          label:
            'Simulate real operating scenarios to visually and quantitatively compare customer pain points, improvement plans, and outcomes—dramatically shortening the time customers need to evaluate your product’s value.',
          videoUrl: require('@/assets/images/home/platform5.mp4'),
        },
        {
          id: '6',
          name: 'Solution Generation Platform',
          label:
            'Generate personalized, multilingual proposals with fully controlled text, layout, and style—based on your selected materials and customer needs—significantly reducing the turnaround time for customized solutions.',
          videoUrl: require('@/assets/images/home/platform6.mp4'),
        },
        {
          id: '7',
          name: 'Demo & Training Platform',
          label:
            'Remotely control live product or system demos to overcome location and distance limitations—enabling on-demand presentations while significantly reducing travel and training costs.',
          videoUrl: require('@/assets/images/home/platform7.mp4'),
        },
      ],
      selectPlatform: '0',
      selectPlatformInfo: {},
      selectStage: '',
      stagePlatform: [],
      toolData1: [
        {
          id: '0',
          name: 'AI Prospecting Agent',
          label: 'Find, analyze, qualify, and engage high-fit prospects automatically before they become leads.',
          img: require('@/assets/images/home/conversion0.png'),
        },
        {
          id: '1',
          name: 'Deeper Customer Insight',
          label: 'Gain a unified view of multilingual customer data to help sales understand needs and motivations with greater depth.',
          img: require('@/assets/images/home/conversion1.png'),
        },
        {
          id: '2',
          name: 'Deeper Customer Need <br/> Understanding & Expertise',
          label: 'Deliver expert engagement through pain point discovery, solution design, simulations, and remote demos.',
          img: require('@/assets/images/home/conversion2.png'),
        },
        {
          id: '3',
          name: 'Advanced Challenge Resolution',
          label: 'Use AI-generated stage-specific strategies and scripts to overcome objections and keep deals moving.',
          img: require('@/assets/images/home/conversion3.png'),
        },
      ],
      selectTool1: '0',
      selectToolInfo1: {},

      toolData2: [
        {
          id: '1',
          name: 'Accelerated Lead & <br /> Discovery & Coverage',
          label: 'Apply a scalable pain-point discovery framework that enables every rep to uncover high-value needs quickly.',
          img: require('@/assets/images/home/conversion4.png'),
        },
        {
          id: '2',
          name: 'Faster, More Responsive <br /> Customer Engagement',
          label: 'Generate marketing assets and tailored proposals within minutes using automated content creation tools.',
          img: require('@/assets/images/home/conversion5.png'),
        },
        {
          id: '3',
          name: 'Streamlined Demo & <br /> POC Experience',
          label: 'Provide on-demand remote demos that bypass scheduling delays and eliminate on-site coordination.',
          img: require('@/assets/images/home/conversion6.png'),
        },
      ],
      selectTool2: '1',
      selectToolInfo2: {},

      toolData3: [
        {
          id: '1',
          name: 'Reduced Sales & <br /> Operational Costs',
          label: 'communication quality with pain point discovery and AI-guided messaging that reduces back-and-forth.',
          img: require('@/assets/images/home/conversion7.png'),
        },
        {
          id: '2',
          name: 'Lower Travel Expenses',
          label: 'Minimize travel expenses by replacing most on-site demos with fully remote interactive sessions.',
          img: require('@/assets/images/home/conversion8.png'),
        },
        {
          id: '3',
          name: 'Reduced Hiring & <br /> Training Costs',
          label: 'Enable new reps to perform at expert level quickly with guided discovery and automated solution generation.',
          img: require('@/assets/images/home/conversion9.png'),
        },
      ],
      selectTool3: '1',
      selectToolInfo3: {},

      platformList: [
        {
          posterUrl: require('@/assets/images/home/platform1.png'),
          videoUrl: '/video/movie.mp4',
          isPlay: false,
          content: {
            title: this.$t('message.index.platform.list[0].content.title'),
            info: [
              {
                iconUrl: require('@/assets/images/home/platform-icon1.png'),
                title: this.$t('message.index.platform.list[0].content.info[0].title'),
                desc: this.$t('message.index.platform.list[0].content.info[0].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon2.png'),
                title: this.$t('message.index.platform.list[0].content.info[1].title'),
                desc: this.$t('message.index.platform.list[0].content.info[1].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon3.png'),
                title: this.$t('message.index.platform.list[0].content.info[2].title'),
                desc: this.$t('message.index.platform.list[0].content.info[2].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[0].content.info[3].title'),
                desc: this.$t('message.index.platform.list[0].content.info[3].desc'),
              },
            ],
          },
        },
        {
          posterUrl: require('@/assets/images/home/platform2.png'),
          videoUrl: '/video/movie.mp4',
          isPlay: false,
          content: {
            title: this.$t('message.index.platform.list[1].content.title'),
            info: [
              {
                iconUrl: require('@/assets/images/home/platform-icon1.png'),
                title: this.$t('message.index.platform.list[1].content.info[0].title'),
                desc: this.$t('message.index.platform.list[1].content.info[0].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon2.png'),
                title: this.$t('message.index.platform.list[1].content.info[1].title'),
                desc: this.$t('message.index.platform.list[1].content.info[1].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon3.png'),
                title: this.$t('message.index.platform.list[1].content.info[2].title'),
                desc: this.$t('message.index.platform.list[1].content.info[2].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[1].content.info[3].title'),
                desc: this.$t('message.index.platform.list[1].content.info[3].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[1].content.info[4].title'),
                desc: this.$t('message.index.platform.list[1].content.info[4].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[1].content.info[5].title'),
                desc: this.$t('message.index.platform.list[1].content.info[5].desc'),
              },
            ],
          },
        },
        {
          posterUrl: require('@/assets/images/home/platform3.png'),
          videoUrl: '/video/movie.mp4',
          isPlay: false,
          content: {
            title: this.$t('message.index.platform.list[2].content.title'),
            info: [
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[2].content.info[0].title'),
                desc: this.$t('message.index.platform.list[2].content.info[0].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon1.png'),
                title: this.$t('message.index.platform.list[2].content.info[1].title'),
                desc: this.$t('message.index.platform.list[2].content.info[1].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon2.png'),
                title: this.$t('message.index.platform.list[2].content.info[2].title'),
                desc: this.$t('message.index.platform.list[2].content.info[2].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon3.png'),
                title: this.$t('message.index.platform.list[2].content.info[3].title'),
                desc: this.$t('message.index.platform.list[2].content.info[3].desc'),
              },
            ],
          },
        },
      ],
      valuesList: [
        {
          iconUrl: require('@/assets/images/home/values-icon2.png'),
          title: this.$t('message.index.values.list[0].title'),
          desc: this.$t('message.index.values.list[0].desc'),
        },
        {
          iconUrl: require('@/assets/images/home/values-icon3.png'),
          title: this.$t('message.index.values.list[1].title'),
          desc: this.$t('message.index.values.list[1].desc'),
        },
        {
          iconUrl: require('@/assets/images/home/values-icon4.png'),
          title: this.$t('message.index.values.list[2].title'),
          desc: this.$t('message.index.values.list[2].desc'),
        },
        {
          iconUrl: require('@/assets/images/home/values-icon5.png'),
          title: this.$t('message.index.values.list[3].title'),
          desc: this.$t('message.index.values.list[3].desc'),
        },
        // {
        //   iconUrl: require('@/assets/images/home/values-icon5.png'),
        //   title: this.$t('message.index.values.list[4].title'),
        //   desc: this.$t('message.index.values.list[4].desc'),
        // },
        // {
        //   iconUrl: require('@/assets/images/home/values-icon6.png'),
        //   title: this.$t('message.index.values.list[5].title'),
        //   desc: this.$t('message.index.values.list[5].desc'),
        // },
      ],

      fifthListData: [
        {
          content: `Previously struggled to clarify client logistics needs. With Xpirory's AI, it quickly identified core pain points and generated proposals/demos rapidly, eliminating back-and-forth. The process efficiency doubled, enabling faster decisions and smoother collaboration.`,
          avatar: require('@/assets/images/home/avatar-en1.png'),
          name: 'Emily Johnson',
          industry: 'Sales Manager',
        },
        {
          content: `Clients often misunderstood warehouse management solutions, and on-site demos were costly. Using the remote demo platform, a Turkish factory client saw the solution in action—doubts were instantly resolved. The project timeline was shortened by over 45 days.`,
          avatar: require('@/assets/images/home/avatar-en2.png'),
          name: 'Michael Carter',
          industry: 'Sales Director',
        },
        {
          content: `Xpirory’s AI platform has been a game-changer. It streamlines customer deep insight, needs analysis, and proposal customization, providing truly powerful support throughout the entire sales process.`,
          avatar: require('@/assets/images/home/avatar-en3.png'),
          name: 'Daniel Brooks',
          industry: 'Account Executive',
        },
        {
          content: `While engaging an electronics factory in Vietnam, the platform automatically gathered and analyzed local data in Vietnamese, quickly identifying the best engagement angle—more than doubling research efficiency. AI simulation also revealed multiple optimization opportunities, cutting pre-sales effort by 50%.`,
          avatar: require('@/assets/images/home/avatar-en4.jpg'),
          name: 'Lucas Anderson',
          industry: 'Business Consultant',
        },
      ],
      differentData: [
        {
          label: 'Actionable Insights, <br />Not Just Data',
          desc: `Xpirory transcends basic data. We use AI to identify real pain points and decision drivers, turning "knowing the customer" into winning the deal.`,
        },
        {
          label: 'End-to-End<br />Prospecting-to-Win Acceleration',
          desc: `Xpirory goes beyond isolated tools to accelerate the entire B2B sales journey.By unifying AI-powered prospect discovery, customer intelligence, solution design, and immersive demos, we help teams identify the right opportunities, make better decisions, and consistently improve win rates.`,
        },
        {
          label: 'Built for Complex <br />Enterprise Sales',
          desc: `Tailored for high-stakes, long-cycle deals. Xpirory streamlines the journey from insight to demo, helping you navigate complex decision chains and secure high-value wins.`,
        },
      ],
      businessEmail: '',
      videoAlive: true,
    };
  },
  mounted() {
    this.matchToolInfo(1);
    this.matchToolInfo(2);
    this.matchToolInfo(3);
    this.matchStageInfo();
    this.matchStagePlatform();
    this.matchPlatformInfo();
    // this.setRem();
  },
  methods: {
    reloadVideo() {
      this.videoAlive = false;
      this.$nextTick(() => {
        this.videoAlive = true;
      })
    },
    jumpContact() {
      this.$router.push(`/contact?email=${this.businessEmail}`);
    },
    // 播放
    playVideo() {
      this.isPlay = true;
      this.$refs.videoPlayer.play().catch(err => console.log(err));
    },
    jumpRoute(route) {
      if (route == '/login') {
        // window.location.href = `https://user.xpirory.com/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`;
      } else {
        this.$router.push(route);
        window.scrollTo(0, 0);
      }
    },
    // 平台按钮组点击，根据平台id匹配平台集合和选中阶段
    changePlatform(data) {
      switch (data) {
        case '0':
          this.stagePlatform = [ { id: '0', level: 'main' }];
          this.selectStage = '0';
          break;
        case '1':
          this.stagePlatform = [
            { id: '1', level: 'main' },
            { id: '4', level: 'minor' },
          ];
          this.selectStage = '1';
          break;
        case '2':
          this.stagePlatform = [{ id: '2', level: 'main' }, { id: '3', level: 'minor' },];
          this.selectStage = '2';
          break;
        case '3':
          this.stagePlatform = [{ id: '3', level: 'main' }, { id: '2', level: 'minor' },];
          this.selectStage = '2';
          break;
        case '4':
          this.stagePlatform = [
            { id: '1', level: 'minor' },
            { id: '4', level: 'main' },
          ];
          this.selectStage = '1';
          break;
        case '5':
          this.stagePlatform = [
            { id: '5', level: 'main' },
            { id: '6', level: 'minor' },
          ];
          this.selectStage = '4';
          break;
        case '6':
          this.stagePlatform = [
            { id: '5', level: 'minor' },
            { id: '6', level: 'main' },
          ];
          this.selectStage = '4';
          break;
        case '7':
          this.stagePlatform = [{ id: '7', level: 'main' }];
          this.selectStage = '3';
          break;
        default:
          break;
      }
      this.matchPlatformInfo();
    },
    // 根据平台集合及主次匹配显示的平台信息(label，video)
    matchPlatformInfo() {
      let platformId = '';
      this.stagePlatform.map(item => {
        if (item.level == 'main') {
          platformId = item.id;
        }
      });
      this.businessData.map(item => {
        if (item.id == platformId) {
          this.selectPlatformInfo = item;
        }
      });
      this.reloadVideo();
    },
    // 鼠标悬浮调用，选中阶段值变更
    changeStage(stage) {
      this.selectStage = stage;
      this.matchStagePlatform();
      this.matchPlatformInfo();
    },
    // 根据当前选中平台匹配选中阶段
    matchStageInfo() {
      switch (this.selectPlatform) {
        case '0':
          this.selectStage = '0';
          break;

        case '1':
          this.selectStage = '1';
          break;

        case '2':
          this.selectStage = '2';
          break;

        case '3':
          this.selectStage = '2';
          break;

        case '4':
          this.selectStage = '1';
          break;

        case '5':
          this.selectStage = '4';
          break;

        case '6':
          this.selectStage = '4';
          break;

        case '7':
          this.selectStage = '3';
          break;

        default:
          break;
      }
    },
    // 根据当前选中阶段匹配赋值当前阶段对应平台
    matchStagePlatform() {
      switch (this.selectStage) {
        case '0':
          this.stagePlatform = [{ id: '0', level: 'main' }];
          break;
        case '1':
          this.stagePlatform = [
            { id: '1', level: 'main' },
            { id: '4', level: 'minor' },
          ];
          break;
        case '2':
          this.stagePlatform = [
            { id: '2', level: 'main' },
            { id: '3', level: 'minor' },
          ];
          break;
        case '3':
          this.stagePlatform = [{ id: '7', level: 'main' }];
          break;
        case '4':
          this.stagePlatform = [
            { id: '5', level: 'main' },
            { id: '6', level: 'minor' },
          ];
          break;
        case '5':
          this.stagePlatform = [{ id: '2', level: 'main' }];
          break;
        default:
          break;
      }
    },
    // 匹配按钮选中类型
    matchPlatformClass(id) {
      let level = '';
      this.stagePlatform.map(item => {
        if (item.id == id) {
          level = item.level;
        }
      });
      return level;
    },
    changeTool(type, data) {
      switch (type) {
        case 1:
          this.selectTool1 = data;
          break;

        case 2:
          this.selectTool2 = data;
          break;

        case 3:
          this.selectTool3 = data;
          break;

        default:
          break;
      }
      this.matchToolInfo(type);
    },
    matchToolInfo(type) {
      switch (type) {
        case 1:
          this.toolData1.map(item => {
            if (item.id == this.selectTool1) {
              this.selectToolInfo1 = item;
            }
          });
          break;

        case 2:
          this.toolData2.map(item => {
            if (item.id == this.selectTool2) {
              this.selectToolInfo2 = item;
            }
          });
          break;

        case 3:
          this.toolData3.map(item => {
            if (item.id == this.selectTool3) {
              this.selectToolInfo3 = item;
            }
          });
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.w-page {
  width: 80%;
}
.section-title {
  margin-bottom: 45px;
}
.play-btn {
  cursor: pointer;
  top: 48%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all .3s;
  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }
}
.banner-section {
  background: url('@/assets/images/home/banner.jpg') center center no-repeat;
  background-size: cover;
  height: 822px;
  margin-bottom: 80px;
  color: var(--text-color);

  .banner-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    padding-top: 30px;
    align-items: center;
    text-align: center;
    // width: 90%;

    .cycleDisplayCn {
      color: #1867ff;
      font-weight: 700;
      font-size: 44px;
    }

    .cycleDisplay {
      font-size: 44px;
      color: #1867ff;
      font-weight: 700;
    }

    .text {
      width: 120%;
      p {
        font-size: 52px;
        font-weight: 600;
        line-height: 80px;
        margin: 0;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    .text2 {
      margin-top: 80px;
      margin-bottom: 92px;
      p {
        font-size: 30px;
        margin: 0;
        margin-bottom: 14px;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    .desc {
      font-size: 24px;
      margin-top: 10px;
      margin-bottom: 30px;
    }

    .desc2 {
      font-size: 14px;
      margin-top: 10px;
      line-height: 1.6;
    }

    .input-box {
      width: 510px;
      height: 50px;
      position: relative;
      .el-input {
        height: 100%;
        ::v-deep {
          .el-input__inner {
            height: 50px;
            line-height: 50px;
            border-radius: 10px !important;
          }
        }
      }
      .el-button {
        position: absolute;
        height: 42px;
        top: 25px;
        right: 5px;
        transform: translateY(-50%);
        box-sizing: border-box;
        border-radius: 10px;
        background-color: #1a65ff;
        padding: 12px 42px;
        font-family: Figtree, Arial, Helvetica;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
}

.platform-section {
  .platform-item {
    .image {
      height: 645px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .platform-content {
      margin-left: 100px;

      h2.content-title {
        font-size: 40px;
        line-height: 1.3;
        margin-bottom: 15px;
      }

      .content-info {
        padding: 10px 0 0;

        .content-icon {
          margin-top: 10px;
        }

        h4.content-title {
          font-size: 22px;
          line-height: 1.4;
        }

        p.desc {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          padding-bottom: 5px;
          border-bottom: 1px solid #272727;
        }
      }

      .content-info:last-of-type {
        border-bottom: none;
      }

      .toUseBtn {
        margin-top: 20px;
        width: 220px;
      }
    }
  }

  .platform-item:nth-of-type(2n) {
    .image {
      order: 1;
    }
  }
}

.business-section {
  padding-top: 0;
  padding-left: 5rem;
  padding-right: 5rem;
  width: 62%;
  .section-title {
    h2 {
      font-size: 36px;
      margin-bottom: 20px;
    }
  }
  .business-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .stage-content {
      margin-bottom: 45px;
      .stage-list {
        .prospecting {
          width: 143px;
          height: 53px;
          border-radius: 35px;
          background-image: linear-gradient(to bottom, #0953ea, #296fff);
          color: #fff;
          font-size: 20px;
          font-weight: 700;
          text-align: center;
          line-height: 53px;
        }
        .lead-or-win {
          width: 53px;
          height: 53px;
          border-radius: 50%;
          background-image: linear-gradient(to bottom, #0953ea, #296fff);
          color: #fff;
          font-size: 20px;
          font-weight: 700;
          text-align: center;
          line-height: 53px;
        }
        .line {
          margin: 0 7px;
          height: 2px;
          background: #1a65ff;
        }
        .line1 {
          width: 30px;
        }
        .line2 {
          width: 72px;
        }
        .line3 {
          width: 92px;
        }
        .line4 {
          width: 53px;
        }
        .line5 {
          width: 68px;
        }
        .line6 {
          width: 152px;
        }
        .stage-item {
          position: relative;
          .stage-text {
            position: absolute;
            font-size: 18px;
            width: 300px;
            left: 0;
            top: -32px;
            color: rgba(1, 13, 57, 0.6);
          }
          .stage-inner {
            cursor: pointer;
            width: 38px;
            height: 38px;
            .check {
              display: block;
            }
            .check-active {
              display: none;
            }
          }
          &.active {
            .stage-text {
              color: #010d39;
              font-weight: 600;
            }
            .check {
              display: none;
            }
            .check-active {
              display: block;
            }
          }
        }
        .triangle {
          width: 0;
          height: 0;
          margin-left: -7px;
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          border-left: 56px solid #296fff;
        }
      }
    }
    .btn-outer {
      width: 110%;
    }

    .btn-wrap {
      display: flex;
      gap: 12px;
      justify-content: center;
      margin-bottom: 20px;
      .btn {
        font-size: 18px;
        border: 1px solid #dcdfe6;
        border-radius: 8px;
        padding: 8px 14px;
        cursor: pointer;
        &.active {
          color: #fff;
          background-color: #1a65ff;
          border-color: #1a65ff;
        }
        &.minor {
          border-color: #1a65ff;
          background-image: linear-gradient(to right, #d4ddf1, #f8fbfe);
        }
      }
    }

    .platform-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      .label {
        margin-top: 20px;
        font-size: 18px;
        color: rgba(16, 19, 35, 0.8);
        line-height: 1.6;
        text-align: left;
      }
      .video-wrap {
        margin-top: 25px;
        video {
          border-radius: 8px;
          width: 85%;
        }
      }
    }
  }
}

.tool-section {
  padding-left: 5rem;
  padding-right: 5rem;
  .section-title {
    h2 {
      font-size: 36px;
      margin-bottom: 20px;
    }
  }
  &.first {
    .tool-content {
      .tool-item {
        .left-wrap {
          .left-item {
            .item-title {
              margin-bottom: 8px;
            }
            .item-desc {
              width: 100%;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  &.second {
    .tool-content {
      .tool-item {
        .left-wrap {
          .left-item {
            .item-title {
              margin-bottom: 6px;
            }
            .item-desc {
              line-height: 24px;
            }
          }
        }
      }
    }
  }
  .tool-content {
    &.special {
      .tool-item {
        flex-direction: row-reverse;
        .left-wrap {
          .left-item.active {
            background: #e2e6ff;
          }
        }
      }
    }
    .tool-item {
      gap: 45px;
      align-items: center;
      .left-wrap {
        width: 34%;
        .left-item {
          padding: 14px 20px;
          background: #f7f8fe;
          border-radius: 8px;
          cursor: pointer;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          &.active {
            background: #fff1e7;
          }
          .item-title {
            font-size: 24px;
            line-height: 1.4;
            margin-bottom: 10px;
            i {
              margin-top: 4px;
            }
          }
          .item-desc {
            width: 90%;
            font-size: 16px;
            line-height: 28px;
            color: rgba(16, 19, 35, 0.8);
          }
        }
      }
      .right-video {
        width: 66%;
        img {
          border-radius: 8px;
        }
      }
    }
  }
}

.advantage-section {
  padding-left: 7rem;
  padding-right: 7rem;
  .section-title {
    margin-bottom: 25px;
    h2 {
      margin-bottom: 15px;
      font-size: 36px;
    }
  }
  .desc {
    font-size: 18px;
    text-align: center;
  }
  .advantage-content {
    margin-top: 45px;
    video {
      border-radius: 6px;
    }
  }
}

.different-section {
  padding-left: 7rem;
  padding-right: 7rem;
  .section-title {
    margin-bottom: 25px;
    font-size: 36px;
    h2 {
      margin-bottom: 15px;
    }
  }
  .section-desc {
    font-size: 18px;
    line-height: 25px;
    color: rgba(16, 19, 35, 0.7);
  }
  .different-content {
    margin-top: 45px;
    .list {
      gap: 30px;
      .list-item {
        width: 33.33%;
        flex: 1;
        border: 1px solid rgba(160, 169, 187, 0.3);
        border-radius: 8px;
        transition: all 0.3s ease;
        .item-inner {
          width: 100%;
          height: 100%;
          padding: 15px;
          .label {
            font-size: 24px;
            font-weight: 600;
            line-height: 1.6;
            margin-bottom: 10px;
          }
          .desc {
            font-size: 16px;
            line-height: 24px;
            color: rgba(16, 19, 35, 0.8);
            text-align: left;
          }
        }
        &:hover {
          background-image: linear-gradient(to bottom, rgba(234, 240, 254, 1), rgba(234, 240, 254, 0));
          box-shadow: 0 0 30px 1px rgba(8, 77, 218, 0.3);
        }
      }
    }

    .stats-grid {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 30px 0;
      border-radius: 10px;
      gap: 25px;

      .stat-item {
        flex: 1;
        min-width: 150px;
        padding: 20px 20px;
        padding-bottom: 10px;
        position: relative;
        border: 1px solid #d9d9d9;
        border-radius: 10px;
        background: #f8f9fe;
        &:hover {
          background-image: linear-gradient(to top, rgba(234, 240, 254, 1), rgba(234, 240, 254, 0));
          box-shadow: 0 0 30px 1px rgba(32, 43, 82, 0.2);
          span, .stat-unit {
            color: #1a65ff!important;
          }
        }
      }

      .stat-number {
        font-size: 60px;
        font-weight: 700;
        color: var(--text-color);
        margin-bottom: 5px;
        .stat-unit:first-child {
          font-size: 48px;
          font-weight: 400;
          color: var(--text-color);
        }
        .stat-unit:last-child {
          font-size: 60px;
          font-weight: 600;
          color: var(--text-color);
        }
      }

      .stat-label {
        font-size: 16px;
        font-weight: 700;
        height: 56px;
        line-height: 25px;
        color: rgba(16, 19, 35, 0.8);
      }
    }
  }
}

.valuation-section {
  width: 100%;
  .section-title {
    h2 {
      font-size: 36px;
      margin-bottom: 20px;
    }
  }

  .valuation-container {
    // height: 800px;
    overflow: hidden;
    position: relative;
    .valuation-content {
      display: flex;
    }

    .valuation-col {
      width: 100%;
      .valuation-list {
        width: 100%;
      }
    }
    .valuation-list {
      display: flex;
      .valuation-item {
        width: 25vw;
        margin-right: -15px;
        padding: 15px 40px;
        padding-top: 30px;
        position: relative;
        .top-content {
          padding: 25px 0 20px;
          line-height: 1.6;
        }
        .user-wrap {
          display: flex;
          align-items: center;
          .avatar {
            margin-right: 10px;
            img {
              width: 52px;
            }
          }
          .user-info {
            .user-name {
              margin-bottom: 8px;
            }
          }
        }
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('@/assets/images/home/valuation-bg.jpg') no-repeat;
          background-size: cover;
          border-radius: 8px;
          z-index: -1;
        }
        &:hover::after {
          background: url('@/assets/images/home/hover-bg.png') no-repeat;
          background-size: cover;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  body .main-layout .stats-grid .stat-number {
    font-size: 86px;
  }

  body .main-layout .stats-grid .stat-unit {
    font-size: 46px;
  }

  body .main-layout .stats-grid .stat-label {
    font-size: 50px;
  }

  body {
    .main-layout {
      .banner-section {
        padding-top: 12px;
        height: 1150px !important;
        .banner-content {
          width: 100%;
          padding-top: 12px;
          .text {
            p {
              line-height: 1.25;
            }
          }
          .input-box {
            width: 810px;
            height: 100px;
            .el-input {
              ::v-deep {
                .el-input__inner {
                  height: 100px;
                  line-height: 100px;
                  border-radius: 24px !important;
                  font-size: 38px;
                }
              }
            }
            .el-button {
              height: 82px;
              top: 50px;
              right: 12px;
              font-size: 34px;
              border-radius: 24px !important;
            }
          }
          .desc2 {
            font-size: 32px;
          }
        }
      }
      .business-section {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        .business-content {
          .stage-content {
            margin-top: 75px;
            margin-bottom: 55px;
            .stage-list {
              .prospecting {
                width: 213px;
                height: 113px;
                font-size: 46px;
                font-weight: 700;
                line-height: 113px;
              }
              .lead-or-win {
                width: 113px;
                height: 113px;
                font-size: 46px;
                font-weight: 700;
                line-height: 113px;
              }
              .line {
                height: 4px;
                margin: 0 17px;
              }
              .line1 {
                width: 45px;
              }
              .line2 {
                width: 112px;
              }
              .line3 {
                width: 142px;
              }
              .line4 {
                width: 173px;
              }
              .line5 {
                width: 218px;
              }
              .line6 {
                width: 252px;
              }
              .stage-item {
                .stage-text {
                  font-size: 36px;
                  width: 520px;
                  top: -65px;
                }
                .stage-inner {
                  width: 78px;
                  height: 78px;
                  i {
                    font-size: 48px !important;
                    font-weight: 600;
                  }
                }
              }
              .triangle {
                margin-left: -16px;
                border-top: 24px solid transparent;
                border-bottom: 24px solid transparent;
                border-left: 114px solid #296fff;
              }
            }
          }
          .btn-wrap {
            gap: 20px;
            margin-bottom: 20px;
            .btn {
              font-size: 36px;
              border-radius: 18px;
            }
          }

          .platform-content {
            .label {
              margin-top: 20px;
              font-size: 32px;
              color: rgba(16, 19, 35, 0.8);
              line-height: 1.6;
            }
            .video-wrap {
              margin-top: 25px;
              video {
                border-radius: 18px;
                width: 85%;
              }
            }
          }
        }
      }
      .tool-section {
        width: 95%;
        padding-left: 12px;
        padding-right: 12px;
        .section-title {
          h2 {
            text-align: center;
          }
        }
        .tool-content {
          .tool-item {
            display: block !important;
            gap: 45px;
            height: auto;
            .left-wrap {
              width: 100%;
              display: flex;
              gap: 40px;
              .left-item {
                width: calc((100% - 80px) / 3);
                padding: 24px 30px;
                border-radius: 18px;
                .item-title {
                  font-size: 48px;
                  line-height: 1.4;
                  margin-bottom: 10px;
                  i {
                    margin-top: 4px;
                  }
                }
                .item-desc {
                  width: 95%;
                  font-size: 32px;
                  line-height: 40px;
                }
              }
            }
            .right-video {
              margin-top: 35px;
              width: 100%;
              img {
                border-radius: 18px;
              }
            }
          }
        }
      }
      .advantage-section {
        width: 95%;
        padding-left: 12px;
        padding-right: 12px;
        .desc {
          font-size: 36px;
        }
        .advantage-content {
          margin-top: 45px;
          img,
          video {
            border-radius: 16px;
          }
        }
      }
      .different-section {
        width: 95%;
        padding-left: 12px;
        padding-right: 12px;
        .section-desc {
          font-size: 32px;
          line-height: 40px;
        }
        .different-content {
          .list {
            gap: 30px;
            .list-item {
              border-radius: 18px;
              .item-inner {
                padding: 15px;
                .label {
                  font-size: 42px;
                  font-weight: 600;
                  line-height: 1.6;
                  margin-bottom: 10px;
                }
                .desc {
                  font-size: 34px;
                  line-height: 48px;
                }
              }
            }
          }

          .stats-grid {
            border-radius: 18px;

            .stat-item {
              padding: 30px;
              padding-bottom: 10px;
              border-radius: 18px;
            }

            .stat-number {
              font-size: 90px;
              font-weight: 700;
              color: var(--text-color);
              margin-bottom: 5px;
              .stat-unit:first-child {
                font-size: 68px;
                font-weight: 400;
                color: var(--text-color);
              }
              .stat-unit:last-child {
                font-size: 90px;
                font-weight: 600;
                color: var(--text-color);
              }
              // &:hover {
              //   span {
              //     color: #1a65ff !important;
              //   }
              // }
            }

            .stat-label {
              font-size: 32px;
              height: 96px;
              line-height: 45px;
            }
          }
        }
      }
      .valuation-section {
        .valuation-container {
          overflow: hidden;
          position: relative;
          height: 750px;
          .valuation-content {
            display: flex;
            height: 100%;
          }

          .valuation-col {
            width: 100%;
            > div {
              height: 100%;
            }
            .valuation-list {
              width: 100%;
            }
          }
          .valuation-list {
            display: flex;
            .valuation-item {
              width: 55vw;
              height: 715px;
              margin-right: -15px;
              padding: 45px 80px;
              position: relative;
              .top-content {
                padding: 25px 0 20px;
                line-height: 1.6;
              }
              .user-wrap {
                display: flex;
                align-items: center;
                .avatar {
                  margin-right: 10px;
                  img {
                    width: 52px;
                  }
                }
                .user-info {
                  .user-name {
                    margin-bottom: 8px;
                  }
                }
              }
              &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('@/assets/images/home/valuation-bg.jpg') no-repeat;
                background-size: cover;
                border-radius: 8px;
                z-index: -1;
              }
              &:hover::after {
                background: url('@/assets/images/home/hover-bg.png') no-repeat;
                background-size: cover;
              }
            }
          }
        }
      }
    }
  }
}
</style>
